interface Props {
  color?: string
  width?: number
  height?: number
}

export const AnalyticsIcon = ({ color = '#6F6F6F', width = 22, height = 23 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.3984 0C20.2266 0.000113919 20.8982 0.671864 20.8984 1.5V22.4707H14.9434V1.5C14.9436 0.671952 15.6153 0.000255464 16.4434 0H19.3984ZM11.9268 6.60352C12.755 6.60363 13.4266 7.27533 13.4268 8.10352V22.4678H7.47168V8.10352C7.47188 7.2753 8.14343 6.60358 8.97168 6.60352H11.9268ZM4.45508 9.90527C5.2832 9.9055 5.95491 10.5771 5.95508 11.4053V22.4668H0V11.4053C0.000173866 10.577 0.671679 9.90527 1.5 9.90527H4.45508ZM16.4434 1C16.1676 1.00026 15.9436 1.22424 15.9434 1.5V21.4707H19.8984V1.5C19.8982 1.22415 19.6743 1.00011 19.3984 1H16.4434ZM8.97168 7.60352C8.69572 7.60358 8.47188 7.82759 8.47168 8.10352V21.4678H12.4268V8.10352C12.4266 7.82762 12.2027 7.60363 11.9268 7.60352H8.97168ZM1.5 10.9053C1.22397 10.9053 1.00017 11.1293 1 11.4053V21.4668H4.95508V11.4053C4.95491 11.1294 4.73092 10.9055 4.45508 10.9053H1.5Z"
        fill={color}
      />
    </svg>
  )
}
